import React from 'react';
import SvgPrize from '../../components/Icons/Prize';
import SvgMember from '../../components/Icons/Member';
import SvgRacket from '../../components/Icons/Racket';
import SvgBall from '../../components/Icons/Ball';
import SvgSocial from '../../components/Icons/Social';
import SvgMembers from '../../components/Icons/Members';
import SvgTennisPlayers from '../../components/Icons/TennisPlayers';
import SvgCalendar from '../../components/Icons/Calendar';
import SvgClock from '../../components/Icons/Clock';
import i18n from '../../lib/i18n';

// `text` alanları artık i18n key'leri tutar (home.<key>). Render edilirken
// ContentBox / ButtonBox component'leri useTranslation ile çözer.
export const homeTopContentBox: Props.ContentBox[] = [
  { key: 'lige-katil', text: 'home:steps.joinLeague', icon: <SvgPrize /> },
  { key: 'rakip-sec', text: 'home:steps.chooseOpponent', icon: <SvgMember /> },
  { key: 'kort-sec', text: 'home:steps.chooseCourt', icon: <SvgRacket /> },
  { key: 'macini-yap', text: 'home:steps.playMatch', icon: <SvgBall /> },
  { key: 'eglen', text: 'home:steps.haveFun', icon: <SvgSocial /> },
];

export const infoLinks: Props.ButtonBox[] = [
  {
    key: 'nasil-katilirim',
    text: 'home:infoLinks.howToJoin',
    icon: <SvgMembers />,
    link: '/akademi/kurallar',
  },
  {
    key: 'nasil-oynaniyor',
    text: 'home:infoLinks.howMatchesPlayed',
    icon: <SvgRacket />,
    link: '/akademi/kurallar',
  },
  {
    key: 'odul-sistemi',
    text: 'home:infoLinks.prizeSystem',
    icon: <SvgPrize />,
    link: '/oduller',
  },
];

export const liveTennisInfo = (
  usersCount: number = 608,
  matchCount: number = 100,
): Props.ContentBox[] => {
  return [
    {
      key: 'tennis-player-count',
      value: usersCount,
      text: 'home:liveTennis.players',
      icon: <SvgTennisPlayers />,
    },
    {
      key: 'match-count',
      value: matchCount,
      text: 'home:liveTennis.matches',
      icon: <SvgCalendar />,
    },
    {
      key: 'total-match-time',
      value: `${matchCount * 60} ${i18n.t('home:liveTennis.minutesShort')}`,
      text: 'home:liveTennis.tennis',
      icon: <SvgClock />,
    },
  ];
};
